import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import BolillaUserDetailsModal from './BolillaUserDetailsModal';
import JokoakNavbar from '../aurrera-jokoak/JokoakNavbar';
import NagusiBackNav from '../common/NagusiBackNav';
import BolillaWidget from './BolillaWidget';
import JokoakSidebarMenu from '../aurrera-jokoak/JokoakSidebarMenu';
import SelectMatchModal from '../aurrera-jokoak/SelectMatchModal';
import JokoakScoringCriteriaCard from '../aurrera-jokoak/JokoakScoringCriteriaCard';
const dayjs = window.dayjs;
export default class BolillaPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.seasonParam = m.route.param('season') || '';
    this.season = this.seasonParam.replace('-', '/');
    this.loading = true;
    this.ranking = [];
    this.matches = [];
    this.expandedUser = null;
    this.expandedMatch = null;
    this.userVotes = {}; // userId -> votes array
    this.matchVotes = {}; // matchId -> votes array

    this.loadData();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    const currentPath = m.route.get() || '';
    const isVoteMode = currentPath.includes('/votar');
    const currentMode = isVoteMode ? 'vote' : 'classification';
    const currentSeason = m.route.param('season') || '';
    if (this.seasonParam !== currentSeason || this.loadedMode !== currentMode) {
      this.seasonParam = currentSeason;
      this.season = this.seasonParam.replace('-', '/');
      this.loadData();
    }
  }
  loadData() {
    this.loading = true;
    const currentPath = m.route.get() || '';
    const isVoteMode = currentPath.includes('/votar');
    const currentMode = isVoteMode ? 'vote' : 'classification';
    this.loadedMode = currentMode;
    this.loadedSeason = this.seasonParam;
    if (isVoteMode) {
      // In vote mode (/votar), only upcoming matches and their votes are needed.
      // No need to load full season classification or all votes from past matches.
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches",
        params: {
          season: this.season,
          upcoming: 1,
          include: 'bolillaVotes,bolillaVotes.user,team,rival'
        }
      }).then(matchesResponse => {
        const matches = app.store.pushPayload(matchesResponse) || [];
        this.matches = matches.sort((a, b) => {
          const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
          const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
          return dateA - dateB;
        });
        this.loading = false;
        m.redraw();
      }).catch(err => {
        this.loading = false;
        console.error(err);
        m.redraw();
      });
    } else {
      // In classification mode (/clasificacion), load classification + matches list
      // without serializing hundreds of votes for each past match.
      const p1 = app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/bolilla-classification",
        params: {
          season: this.seasonParam
        }
      });
      const p2 = app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches",
        params: {
          season: this.season,
          include: 'team,rival'
        }
      });
      Promise.all([p1, p2]).then(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          rankingResponse = _ref2[0],
          matchesResponse = _ref2[1];
        this.ranking = app.store.pushPayload(rankingResponse) || [];
        const matches = app.store.pushPayload(matchesResponse) || [];
        this.matches = matches.sort((a, b) => {
          const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
          const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
          return dateA - dateB;
        });
        this.loading = false;
        m.redraw();
      }).catch(err => {
        this.loading = false;
        console.error(err);
        m.redraw();
      });
    }
  }
  showUserDetails(entry) {
    if (!entry) return;
    app.modal.show(BolillaUserDetailsModal, {
      entry,
      season: this.seasonParam
    });
  }
  toggleMatch(match) {
    const matchId = match.id();
    if (this.expandedMatch === matchId) {
      this.expandedMatch = null;
    } else {
      this.expandedMatch = matchId;
      if (!this.matchVotes[matchId]) {
        this.loadMatchVotes(matchId);
      }
    }
  }
  loadMatchVotes(matchId) {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/bolilla-match-votes",
      params: {
        matchId,
        include: 'user'
      }
    }).then(response => {
      this.matchVotes[matchId] = app.store.pushPayload(response) || [];
      m.redraw();
    });
  }
  scrollToUser(userId) {
    let el = document.getElementById("bolilla-user-row-".concat(userId));
    if (!el) {
      el = document.getElementById("bolilla-podium-user-".concat(userId));
    }
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      el.classList.remove('is-flashing');
      // Force reflow
      void el.offsetWidth;
      el.classList.add('is-flashing');
      setTimeout(() => {
        if (el) el.classList.remove('is-flashing');
      }, 2600);
    }
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    const ranks = [];
    const ties = [];
    let currentRank = 1;
    for (let i = 0; i < this.ranking.length; i++) {
      if (i > 0 && this.ranking[i].totalPoints() !== this.ranking[i - 1].totalPoints()) {
        currentRank = i + 1;
      }
      ranks[i] = currentRank;
    }
    for (let i = 0; i < this.ranking.length; i++) {
      const r = ranks[i];
      ties[i] = ranks.filter(x => x === r).length > 1;
    }
    const top3 = this.ranking.slice(0, 3);
    const activeBolillaMatches = this.matches.filter(match => {
      const matchDate = match.matchDate();
      if (!matchDate) return false;
      const deadline = dayjs(matchDate).subtract(2, 'hours');
      return dayjs().isBefore(deadline) && match.scoreAthletic() === null;
    }).sort((a, b) => new Date(a.matchDate()).getTime() - new Date(b.matchDate()).getTime());
    const currentPath = m.route.get() || '';
    const isVoteMode = currentPath.includes('/votar');
    const season = this.seasonParam || '2025-2026';
    return m("div", {
      className: "BolillaPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "La Bolilla"
    }), m("h2", {
      className: "BolillaPage-Title"
    }, "La Bolilla"), m(JokoakNavbar, null), m("div", {
      className: "JokoakSubmenu"
    }, m(Link, {
      href: "/la-bolilla/".concat(season, "/clasificacion"),
      className: "JokoakSubmenu-link ".concat(!isVoteMode ? 'active' : '')
    }, "\uD83C\uDFC6 Clasificaci\xF3n"), m(Link, {
      href: "/la-bolilla/".concat(season, "/votar"),
      className: "JokoakSubmenu-link ".concat(isVoteMode ? 'active' : '')
    }, "\uD83D\uDD2E Votar")), isVoteMode ? activeBolillaMatches.length > 0 ? m("div", {
      id: "bolilla-vote",
      className: "ActiveGameSection BolillaActiveSection",
      style: "margin-bottom: 40px; display: flex; flex-direction: column; gap: 20px;"
    }, m("div", {
      className: "BolillaVoteHeader"
    }, m("h3", null, m("span", {
      style: "font-size: 1.2em;"
    }, "\uD83D\uDD2E"), "Pronosticar Pr\xF3ximos Partidos (", activeBolillaMatches.length, ")")), activeBolillaMatches.map((match, index) => {
      const isExpanded = this.expandedMatchId === match.id() || this.expandedMatchId === undefined && index === 0;
      const matchDate = match.matchDate();
      const currentUserId = app.session.user ? app.session.user.id() : null;
      const userVote = currentUserId && (match.bolillaVotes() || []).find(v => {
        const vUid = v.user() ? v.user().id() : typeof v.userId === 'function' ? v.userId() : v.userId;
        return String(vUid) === String(currentUserId);
      });
      return m("div", {
        key: match.id(),
        className: "BolillaMatchCard"
      }, m("div", {
        className: "BolillaMatchCard-header",
        onclick: () => {
          this.expandedMatchId = isExpanded ? null : match.id();
          m.redraw();
        }
      }, m("div", {
        style: "display: flex; align-items: center; gap: 12px;"
      }, m("span", {
        style: "font-size: 1.2em; font-weight: 800; color: #ee2523; background: rgba(238,37,35,0.08); padding: 4px 10px; border-radius: 8px;"
      }, "#", index + 1), m("div", null, m("h4", {
        style: "font-size: 1.2em; font-weight: 800; margin: 0; color: var(--heading-color);"
      }, typeof match.renderName === 'function' ? match.renderName({
        showJornada: true
      }) : match.getName()), matchDate && m("div", {
        style: "font-size: 0.85em; color: var(--muted-color); font-weight: 600; margin-top: 2px;"
      }, m("i", {
        className: "far fa-clock",
        style: "margin-right: 5px;"
      }), dayjs(matchDate).format('D MMMM YYYY, HH:mm'), " h"))), m("div", {
        style: "display: flex; align-items: center; gap: 12px;"
      }, app.session.user && (userVote ? m("span", {
        style: "font-size: 0.85em; font-weight: 700; color: #10b981; background: rgba(16,185,129,0.12); padding: 5px 12px; border-radius: 20px; border: 1px solid rgba(16,185,129,0.3); display: inline-flex; align-items: center; gap: 6px;"
      }, m("i", {
        className: "fas fa-check-circle"
      }), " Votado: ", m("strong", {
        style: "font-family: monospace;"
      }, userVote.votedScore ? userVote.votedScore() : userVote.votedScore)) : m("span", {
        style: "font-size: 0.85em; font-weight: 700; color: #f59e0b; background: rgba(245,158,11,0.12); padding: 5px 12px; border-radius: 20px; border: 1px solid rgba(245,158,11,0.3); display: inline-flex; align-items: center; gap: 6px;"
      }, m("i", {
        className: "fas fa-clock"
      }), " Pendiente")), m("i", {
        className: "fas fa-chevron-".concat(isExpanded ? 'up' : 'down'),
        style: "color: var(--muted-color);"
      }))), isExpanded && m("div", {
        className: "BolillaMatchCard-body"
      }, m(BolillaWidget, {
        match: match,
        key: match.id()
      })));
    })) : m("div", {
      className: "ActiveGameSection BolillaNoActiveGame"
    }, m("span", {
      style: "font-size: 3em;"
    }, "\uD83D\uDD2E"), m("h3", {
      style: "font-weight: 800; margin-top: 15px;"
    }, "No hay pron\xF3sticos activos"), m("p", {
      style: "margin-bottom: 20px;"
    }, "Todos los partidos ya han comenzado o no hay partidos programados en este momento."), m(Link, {
      href: "/la-bolilla/".concat(season, "/clasificacion"),
      className: "Button Button--primary",
      style: "border-radius: 20px; font-weight: bold; padding: 8px 24px;"
    }, "\uD83C\uDFC6 Ver Clasificaci\xF3n General")) : m("div", {
      id: "bolilla-classification"
    }, m(JokoakScoringCriteriaCard, {
      game: "bolilla"
    }), top3.length > 0 && m("div", {
      className: "SeasonOverview"
    }, m("div", {
      className: "Podium"
    }, top3[1] && this.renderPodiumUser(top3[1], ranks[1]), top3[0] && this.renderPodiumUser(top3[0], ranks[0]), top3[2] && this.renderPodiumUser(top3[2], ranks[2]))), m("div", {
      className: "Stats-Main-Content"
    }, m("div", {
      className: "Season-Statistics"
    }, m("div", {
      className: "Top-Players-Full-Table"
    }, m("div", {
      className: "Classification-Header-Actions"
    }, m("h4", null, "Clasificaci\xF3n General"), (() => {
      const currentUserId = app.session.user ? app.session.user.id() : null;
      if (!currentUserId) return null;
      const userRankIndex = this.ranking.findIndex(entry => entry.user() && String(entry.user().id()) === String(currentUserId));
      if (userRankIndex === -1) return null;
      const myRank = ranks[userRankIndex];
      return m(Button, {
        className: "Button Button--my-position",
        onclick: () => this.scrollToUser(currentUserId),
        icon: "fas fa-crosshairs"
      }, m("span", null, "Mi posici\xF3n (", myRank, "\xBA)"));
    })()), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, "Usuario"), m("th", {
      className: "center"
    }, "Partidos"), m("th", {
      className: "center"
    }, "Puntos"), m("th", {
      className: "center"
    }, "Detalles"))), m("tbody", null, this.ranking.map((entry, index) => {
      const user = entry.user();
      if (!user) return null;
      const isCurrent = app.session.user && String(app.session.user.id()) === String(user.id());
      const userUrl = app.route('user', {
        username: user.slug()
      });
      const rank = ranks[index];
      return m("tr", {
        key: user.id(),
        id: "bolilla-user-row-".concat(user.id()),
        className: isCurrent ? 'highlight-current-user' : ''
      }, m("td", null, m("div", {
        className: "Player-Table-Info"
      }, m("span", {
        className: "rank-badge-cell"
      }, m("span", {
        className: "rank-badge rank-".concat(rank)
      }, rank, "\xBA")), m(Link, {
        href: userUrl
      }, avatar(user, {
        className: 'Player-Avatar-Tiny'
      })), m(Link, {
        href: userUrl,
        className: "Player-Name"
      }, username(user)), isCurrent && m("span", {
        className: "badge-you"
      }, "T\xDA"))), m("td", {
        className: "center"
      }, entry.matchesVoted()), m("td", {
        className: "center bold"
      }, entry.totalPoints()), m("td", {
        className: "center"
      }, m(Button, {
        className: "Button Button--link",
        onclick: () => this.showUserDetails(entry),
        icon: "fas fa-info-circle"
      }, m("span", {
        className: "Button-label"
      }, "Detalles"))));
    })))))), m("div", {
      className: "Matches-Classification-List"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; flex-wrap: wrap; gap: 10px;"
    }, m("h4", {
      className: "Section-Title",
      style: "margin: 0;"
    }, "Historial de Partidos"), (() => {
      const playedMatches = this.matches.filter(m => m.getScore() || m.matchDate() && new Date(m.matchDate()).getTime() < Date.now());
      const lastPlayed = playedMatches.length > 0 ? playedMatches[playedMatches.length - 1] : null;
      if (!lastPlayed) return null;
      return m(Button, {
        className: "Button Button--secondary",
        onclick: () => {
          const el = document.getElementById("bolilla-match-".concat(lastPlayed.id()));
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        },
        style: "border-radius: 20px; font-weight: bold; padding: 6px 14px; font-size: 13px;"
      }, m("i", {
        className: "fas fa-arrow-down",
        style: "margin-right: 6px;"
      }), "Ir al \xFAltimo partido disputado");
    })()), m("div", {
      className: "Matches-Grid"
    }, this.matches.map(match => this.renderMatchItem(match))))))));
  }
  renderPodiumUser(entry, position) {
    const user = entry.user();
    if (!user) return null;
    const isFirst = position === 1;
    const isCurrent = app.session.user && String(app.session.user.id()) === String(user.id());
    const userUrl = app.route('user', {
      username: user.slug()
    });
    const pathId = 'txapela-podium-path-' + Math.random().toString(36).substr(2, 9);
    return m("div", {
      id: "bolilla-podium-user-".concat(user.id()),
      className: "Podium-Player pos-".concat(position, " ").concat(isFirst ? 'MVP' : '', " ").concat(isCurrent ? 'highlight-current-user' : '')
    }, m(Link, {
      href: userUrl,
      className: "Player-Avatar-Wrapper"
    }, avatar(user), m("div", {
      className: "Rank-Badge"
    }, position), isFirst && m("div", {
      className: "MVP-Txapela"
    }, m("svg", {
      viewBox: "0 0 100 45",
      className: "txapela-svg",
      xmlns: "http://www.w3.org/2000/svg"
    }, m("defs", null, m("path", {
      id: pathId,
      d: "M 8,24 Q 50,13 92,24",
      fill: "none",
      stroke: "none"
    })), m("ellipse", {
      cx: "50",
      cy: "30",
      rx: "35",
      ry: "8",
      fill: "rgba(0, 0, 0, 0.25)"
    }), m("path", {
      d: "M 8,24 C 8,6 92,6 92,24 C 92,36 8,36 8,24 Z",
      fill: "#1e1e1f"
    }), m("path", {
      d: "M 20,28 Q 50,34 80,28 Q 50,23 20,28 Z",
      fill: "#131314"
    }), m("path", {
      d: "M 50,11 Q 50,4 51,2 Q 53,4 53,11 Z",
      fill: "#1e1e1f"
    }), m("text", {
      fill: "#ffffff",
      "font-size": "5",
      "font-weight": "900",
      "letter-spacing": "0.8",
      stroke: "#ffd700",
      "stroke-width": "0.15px",
      dy: "1.5",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, m("textPath", {
      href: "#".concat(pathId),
      startOffset: "50%",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, "TXAPELDUN"))))), m("div", {
      className: "Player-Details"
    }, m(Link, {
      href: userUrl,
      className: "Player-Name"
    }, username(user), isCurrent && m("span", {
      className: "badge-you"
    }, "T\xDA")), m("div", {
      className: "Player-Score-Container"
    }, m("span", {
      className: "Player-Average"
    }, entry.totalPoints()), m("span", {
      className: "Label"
    }, "puntos"))));
  }
  renderMatchItem(match) {
    const isExpanded = this.expandedMatch === match.id();
    const isLoading = this.expandedMatch === match.id() && !this.matchVotes[match.id()];
    const matchVotes = this.matchVotes[match.id()] || [];
    const matchDate = match.matchDate() ? dayjs(match.matchDate()).format('DD/MM/YYYY') : '';
    return m("div", {
      className: "MatchRow-Card ".concat(isExpanded ? 'is-expanded' : ''),
      id: "bolilla-match-".concat(match.id()),
      key: match.id(),
      style: "background: #fff; border-radius: 12px; margin-bottom: 15px; box-shadow: 0 4px 6px rgba(0,0,0,0.03); border: 1px solid #eee; overflow: hidden;"
    }, m("div", {
      className: "MatchRow-Header",
      onclick: () => this.toggleMatch(match)
    }, m("div", {
      className: "MatchRow-Info"
    }, m("div", {
      className: "MatchRow-Title"
    }, match.renderName()), m("div", {
      className: "MatchRow-Meta"
    }, m("span", {
      className: "MatchRow-Date"
    }, m("i", {
      className: "far fa-calendar-alt MatchDate-Icon"
    }), " ", matchDate))), m("div", {
      className: "MatchRow-Toggle"
    }, m("i", {
      className: "fas ".concat(isExpanded ? 'fa-chevron-up' : 'fa-chevron-down')
    }))), isExpanded && m("div", {
      className: "MatchRow-Body",
      style: "padding: 20px; border-top: 1px solid #f0f0f0; background: #fafafa;"
    }, isLoading ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m("div", {
      className: "Match-Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, "Usuario"), m("th", {
      className: "center"
    }, "Voto"), m("th", {
      className: "center"
    }, "Puntos"))), m("tbody", null, matchVotes.length > 0 ? matchVotes.map((vote, index) => {
      const voteUser = vote.user();
      if (!voteUser) return null;
      const isCurrent = app.session.user && String(app.session.user.id()) === String(voteUser.id());
      return m("tr", {
        key: vote.id(),
        className: isCurrent ? 'highlight-current-user' : ''
      }, m("td", null, m("div", {
        className: "Player-Table-Info"
      }, avatar(voteUser, {
        className: 'Player-Avatar-Tiny'
      }), m("span", {
        className: "Player-Name"
      }, username(voteUser)), isCurrent && m("span", {
        className: "badge-you"
      }, "T\xDA"))), m("td", {
        className: "center"
      }, m("span", {
        className: "vote-score"
      }, vote.votedScore()), match.isKnockout() && vote.votedKnockoutWinner() && m("div", {
        className: "winner-tag",
        style: "font-size: 0.8em; color: #666;"
      }, "(Pasa: ", vote.votedKnockoutWinner(), ")")), m("td", {
        className: "center bold"
      }, m("div", {
        className: "points-display"
      }, "+", vote.points(), match.isKnockout() && (vote.points() === 1 || vote.points() === 4) && m("span", {
        className: "pill winner-pill",
        title: "Punto por eliminatoria"
      }, "+1"))));
    }) : m("tr", null, m("td", {
      colspan: "3",
      className: "center"
    }, "Nadie particip\xF3 en este partido.")))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/bolilla/BolillaPage', BolillaPage);